// Applicants
export interface Applicant {
  applicantType: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  addresses?: Address[];
  phoneNumbers?: PhoneNumber[];
  email?: string;
  applicantId?: string;
  relationshipToApplicant?: RelationshipToApplicant;
}

export interface Applicants {
  applicant: Applicant[];
}

export enum RelationshipToApplicant {
  JointAndSpousal = 'JointAndSpousal',
  JointAndNonSpousal = 'JointAndNonSpousal',
  CoSignerAndNonSpousal = 'CoSignerAndNonSpousal'
}

// Address
export interface Address {
  addressType: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zip: string;
}

export interface Addresses {
  address?: Address;
}

// Phone
export interface PhoneNumber {
  phoneType: string;
  // TODO: All eslint errors need to be addressed, but this one seems very problematic.
  // eslint-disable-next-line id-blacklist
  number: string;
}

export interface PhoneNumbers {
  phoneNumber: PhoneNumber[];
}

// added to postapp/models/application
// consolidated into Applicant
export interface OAOApplicantDetails {
  /** firstname of applicant */
  firstName: string;
  /** lastname of applicant */
  lastName: string;
  /** type of applicant */
  applicantType: string;
}
